import { loadProductReducer } from '../../product/reducers/ProductReducer';
import productSaga from '../../product/sagas/ProductSagas';
const loadProductModule = (initialData) => ({
    id: 'Product',
    reducerMap: {
        product: loadProductReducer(initialData ? initialData.product : null),
    },
    sagas: [productSaga],
});
export default loadProductModule;
